import React from 'react';
import {getAccreditationBodiesHaveStandards} from 'api/accreditation-bodies';

import {SelectSearchBase} from 'components/Forms/FormBases';

class SelectABHasStandards extends React.Component {
  static defaultProps = {
    isClearable: true,
    cacheOptions: true,
    defaultOptions: true,
    isDisabled: false,
    name: 'accreditation_bodies_id',
    placeholder: 'Accreditation Bodies',
    filters: {},
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
      value: props.defaultValue || '',
      inputValue: '',
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const {defaultOptions} = this.props;

    if (defaultOptions) this.loadOptions();
  }

  componentDidUpdate(prevProps) {
    const {certification_bodies_id} = this.props.filters;

    if (prevProps.filters.certification_bodies_id !== certification_bodies_id) {
      this.loadOptions();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadOptions() {
    const {isDisabled, filters} = this.props;

    if (isDisabled) {
      return false;
    }

    if (!filters.certification_bodies_id) {
      this.setState({
        value: '',
        options: [],
      });

      return false;
    }

    this.setState(
      {
        isLoading: true,
      },
      () => {
        const {filters} = this.props;
        const {inputValue} = this.state;

        const queries = {
          ...filters,
          search: inputValue,
          order: 'ASC',
          order_by: 'accreditation_bodies_name',
        };

        getAccreditationBodiesHaveStandards(queries).then(({data}) => {
          if (!this._isMounted) return false; // Check Mounted
          this.setState({
            options: data,
            isLoading: false,
          });
        });
      }
    );
  }

  handleChange(data, callback) {
    this.setState({value: data}, callback(data));
  }

  render() {
    const {value, defaultOptions, filters, onChange, ...rest} = this.props;

    return (
      <SelectSearchBase
        value={this.state.value}
        options={this.state.options}
        isLoading={this.state.isLoading}
        getOptionLabel={(option) => option.accreditation_bodies_name}
        getOptionValue={(option) => option.accreditation_bodies_id}
        onChange={(obj) => this.handleChange(obj, onChange)}
        {...rest}
      />
    );
  }
}

export default SelectABHasStandards;
